import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
import { defaultSmDate } from '../utils/formatter';
// eslint-disable-next-line import/no-cycle
import { ArtikelEigenschaft } from './artikelEigenschaft';
// eslint-disable-next-line import/no-cycle
import { Artikel } from './artikel';
import { ArtikelDetailHistorie } from './artikelDetailHistorie';
import { BaseResult } from './base';
// eslint-disable-next-line import/no-cycle
import { ArtikelDetailLieferant } from './artikelDetailLieferant';
import { ArtikelDetailKalkulation } from './artikelDetailKalkulation';

export interface ArtikelDetail {
    artikelGruppeNr: number;
    artikelNr: string;
    lagerArtikelNr: string;
    text: string;
    archiv: boolean;
    suffix: number;
    nrKunde: string;
    lagerIntNr: number;
    bestand: number;
    minBestand: number;
    minBestMenge: number;
    bestZeit: number;
    offenBest: number;
    offenBestD: number;
    offenLief: number;
    offenLiefD: number;
    offenRes: number;
    artikelArchiv: boolean;
    verbrD: number;
    verbrKalkDat: string;
    regal: string;
    fach: number;
    produktGruppeNr: number;
    produzentNr: number;
    drehung: number;
    drehungAnz: number;

    artikel?: Artikel;
    hauptlieferant?: ArtikelDetailLieferant;
    defaultKalkulation?: ArtikelDetailKalkulation;
    artikelEigenschaftList?: ArtikelEigenschaft[];
    artikelDetailHistorie?: ArtikelDetailHistorie[];

    anlageDat?: string;
    anlageUhr?: number;
    anlageUser?: string;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export const defaultArtikelDetail = {
    artikelGruppeNr: 0,
    artikelNr: '',
    lagerArtikelNr: '',
    text: '',
    archiv: false,
    suffix: 0,
    nrKunde: '',
    lagerIntNr: 0,
    bestand: 0,
    minBestand: 0,
    minBestMenge: 0,
    bestZeit: 0,
    offenBest: 0,
    offenBestD: 0,
    offenLief: 0,
    offenLiefD: 0,
    offenRes: 0,
    artikelArchiv: false,
    verbrD: 0,
    verbrKalkDat: defaultSmDate,
    regal: '',
    fach: 0,
    produktGruppeNr: 0,
    produzentNr: 0,
    drehung: 0,
    drehungAnz: 0,
};

export interface ArtikelDetailFilter {
    artikelGruppeNr?: number;
    artikelGruppeNrList?: number[];
    artikelNr?: string;
    lagerIntNr?: number;
    lagerIntNrList?: number[];
    searchText?: string;
    searchTextFromBeginning?: boolean;
    searchTextMultiPart?: boolean;
    einheit?: string;
    maschinentypeNr?: number;
    staerkeVon?: number;
    staerkeBis?: number;
    breiteVon?: number;
    breiteBis?: number;
    halbeBreite?: boolean;
    laufmeterVon?: number;
    laufmeterBis?: number;
    quadrmeterVon?: number;
    quadrmeterBis?: number;
    minBestandVon?: number;
    bestandBelowMinBestand?: boolean;
    verfuegbarBelowMinBestand?: boolean;
    bestandVon?: number;
    offenBestVon?: number;
    offenBestVonD?: number;
    offenLiefVon?: number;
    offenLiefVonD?: number;
    offenResVon?: number;
    minVerfuegbar?: number;
    includeArchiv?: boolean;
    maxRows?: number;
    withHauptlieferant?: boolean;
    withDefaultKalkulation?: boolean;
    withArtikelEigenschaften?: boolean;
    withArtikelDetailHistorie?: boolean;
    withDrehung?: boolean;
}

export function useArtikelDetail(
    filter: ArtikelDetailFilter,
    apiOptions?: UseApiOptions<ArtikelDetail>,
): QueryResult<ArtikelDetail> {
    return useApi<ArtikelDetail>(Controller.artikelDetail + '/one', { filter }, apiOptions);
}

export function useArtikelDetailList(
    filter: ArtikelDetailFilter,
    apiOptions?: UseApiOptions<ArtikelDetail[]>,
): QueryResult<ArtikelDetail[]> {
    return useApi<ArtikelDetail[]>(Controller.artikelDetail + '/list', { filter }, apiOptions);
}

export async function getArtikelDetail(filter: ArtikelDetailFilter): Promise<ArtikelDetail> {
    return callApi<ArtikelDetail>(Controller.artikelDetail + '/one', {
        filter,
    });
}

export async function addArtikelDetail(artikelDetail: ArtikelDetail): Promise<void> {
    return callApi<void>(Controller.artikelDetail + '/add', { artikelDetail });
}

export async function updateArtikelDetail(artikelDetail: ArtikelDetail): Promise<void> {
    return callApi<void>(Controller.artikelDetail + '/update', { artikelDetail });
}

export async function korrekturArtikelDetail(artikelDetail: ArtikelDetail, note: string): Promise<BaseResult> {
    return callApi<BaseResult>(Controller.artikelDetail + '/korrektur', { artikelDetail, note });
}
